var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag",class:_vm.tagClassName},[_vm._t("content"),_vm._v(" "),_vm._t("post-icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }